import { GoalFormField, GoalRecommendationType } from '../../common/types';
import { uipApiInstance } from '../index';

export const fetchClients = async (data: { tenant: string }) => {
    try {
        const response = await uipApiInstance.get('/api/advice/getproposals?tenant=' + data.tenant);
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

export interface ProposalDetailData {
    _id: string;
    api_name: string;
    api_ver: string;
    tenant: string;
    assignedClientId: string;
    form_fields: GoalFormField[];
    request: Record<string, unknown>[];
    response: Record<string, unknown>[];
    is_multi_goal: boolean;
    iws_applied: boolean;
    goeConfigEmail: string;
    global: { recommendation?: GoalRecommendationType[] } & Record<string, unknown>;
    rebalancer_ref_id?: Record<string, unknown>;
    da_advice_id?: string;
    participant_id?: string;
    profile?: { participant_id?: string; isParticipantIdAvailable?: boolean } & Record<string, unknown>;
    // AEX-3363: client details now nest under data.client_profile (was data.profile); the
    // optimistic-concurrency reference ids ride alongside so the FE can echo them on updates.
    client_profile?: { client_ref_id?: string; participant_id?: string } & Record<string, unknown>;
    proposal_ref_id?: string;
    tenant_info_ref_id?: string | null;
}

export const mpgetproposaldetail = async (data: {
    proposalId: string;
    tenant: string;
}): Promise<ProposalDetailData> => {
    const response = await uipApiInstance.get<{ data: ProposalDetailData; success: boolean }>(
        `/api/advice/mpgetproposaldetail/${data.proposalId}?tenant=${data.tenant}`
    );
    return response.data.data;
};
